var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _circle, _circle2, _circle3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _g, _path146, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSosShort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 230,
    viewBox: "0 0 189 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10322_11211)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10322_11211)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 185,
    height: 226,
    rx: 24,
    fill: "#0E5A90"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.2227 200.982C21.3922 203.408 21.7315 234.806 18 252.625V269.542L233.746 278L237.477 155.861C244.601 118.644 176.982 98.4061 151.315 122.365C124.855 147.064 129.265 197.937 69.2227 200.982Z",
    fill: "#628EB3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.467 209.913H117.947V222.035H128.467V209.913Z",
    fill: "#463332"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.467 212.462H117.947V216.261H128.467V212.462Z",
    fill: "#463332"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.886 153H86.5182C84.3255 153 82.548 154.778 82.548 156.97V208.391C82.548 210.584 84.3255 212.361 86.5182 212.361H159.886C162.078 212.361 163.856 210.584 163.856 208.391V156.97C163.856 154.778 162.078 153 159.886 153Z",
    fill: "url(#paint0_linear_10322_11211)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5481 205.177V208.532C82.5481 210.83 84.3215 212.694 86.5182 212.694H159.886C162.083 212.694 163.856 210.83 163.856 208.532V205.177H82.5481Z",
    fill: "url(#paint1_linear_10322_11211)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M158.397 154.226H88.1867C86.0877 154.226 84.3861 155.94 84.3861 158.055V199.411C84.3861 201.526 86.0877 203.241 88.1867 203.241H158.397C160.496 203.241 162.197 201.526 162.197 199.411V158.055C162.197 155.94 160.496 154.226 158.397 154.226Z",
    fill: "url(#paint2_linear_10322_11211)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3861 159.74C84.3861 156.694 86.8549 154.226 89.9003 154.226H156.683C159.729 154.226 162.197 156.694 162.197 159.74H84.3861Z",
    fill: "url(#paint3_linear_10322_11211)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86.2241,
    y: 162.804,
    width: 7.35225,
    height: 2.45075,
    fill: "#DDC8BA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 94.1891,
    y: 162.804,
    width: 7.35225,
    height: 2.45075,
    fill: "#DDC8BA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 147.493,
    y: 162.804,
    width: 4.28881,
    height: 1.83806,
    rx: 0.919031,
    fill: "#FFB183"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 153.007,
    y: 162.804,
    width: 7.35225,
    height: 1.83806,
    rx: 0.919031,
    fill: "#D4F7E2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 86.2241,
    y: 166.479,
    width: 23.8948,
    height: 4.28881,
    rx: 2,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 86.2241,
    y: 171.994,
    width: 23.8948,
    height: 13.4791,
    rx: 2,
    fill: "#FFE1D1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 88.0622,
    y: 174.444,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint4_linear_10322_11211)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 88.0622,
    y: 179.959,
    width: 18.9933,
    height: 1.22537,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 86.2241,
    y: 186.698,
    width: 23.8948,
    height: 14.7045,
    rx: 2,
    fill: "#F2F2F2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 111.957,
    y: 186.698,
    width: 23.8948,
    height: 14.7045,
    rx: 2,
    fill: "#F2F2F2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 137.077,
    y: 186.698,
    width: 23.8948,
    height: 14.7045,
    rx: 2,
    fill: "#F2F2F2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 111.957,
    y: 166.479,
    width: 23.8948,
    height: 4.28881,
    rx: 2,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 137.619,
    y: 166.479,
    width: 23.8948,
    height: 4.28881,
    rx: 2,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 89.2876,
    y: 189.149,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint5_linear_10322_11211)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 89.2877,
    y: 194.663,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint6_linear_10322_11211)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 96.0272,
    y: 189.149,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint7_linear_10322_11211)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 96.0272,
    y: 194.663,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint8_linear_10322_11211)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 102.767,
    y: 189.149,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint9_linear_10322_11211)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 102.767,
    y: 194.663,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint10_linear_10322_11211)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 115.02,
    y: 189.149,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint11_linear_10322_11211)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 115.021,
    y: 194.663,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint12_linear_10322_11211)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 121.76,
    y: 189.149,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint13_linear_10322_11211)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 121.76,
    y: 194.663,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint14_linear_10322_11211)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 128.5,
    y: 189.149,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint15_linear_10322_11211)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 128.5,
    y: 194.663,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint16_linear_10322_11211)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 140.141,
    y: 189.762,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint17_linear_10322_11211)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 140.141,
    y: 195.276,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint18_linear_10322_11211)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 146.88,
    y: 189.762,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint19_linear_10322_11211)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 146.88,
    y: 195.276,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint20_linear_10322_11211)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 153.62,
    y: 189.762,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint21_linear_10322_11211)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 153.62,
    y: 195.276,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint22_linear_10322_11211)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 111.957,
    y: 171.994,
    width: 23.8948,
    height: 14.0918,
    rx: 2,
    fill: "#FFE1D1"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 113.795,
    y: 173.832,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint23_linear_10322_11211)"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 113.795,
    y: 178.121,
    width: 18.9933,
    height: 1.22537,
    fill: "white"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 113.795,
    y: 180.571,
    width: 18.9933,
    height: 1.22537,
    fill: "white"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 113.795,
    y: 183.022,
    width: 18.9933,
    height: 1.22537,
    fill: "white"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 137.619,
    y: 171.994,
    width: 23.8948,
    height: 14.0918,
    rx: 2,
    fill: "#FFE1D1"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 139.457,
    y: 173.832,
    width: 3.67612,
    height: 3.67612,
    rx: 1.83806,
    fill: "url(#paint24_linear_10322_11211)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 139.457,
    y: 178.121,
    width: 18.9933,
    height: 1.22537,
    fill: "white"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 139.457,
    y: 180.571,
    width: 18.9933,
    height: 1.22537,
    fill: "white"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 139.457,
    y: 183.022,
    width: 18.9933,
    height: 1.22537,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 149.331,
    cy: 157.289,
    r: 1.22537,
    fill: "url(#paint25_linear_10322_11211)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.394,
    cy: 157.289,
    r: 1.22537,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.458,
    cy: 157.289,
    r: 1.22537,
    fill: "url(#paint26_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.972 155.406C160.281 154.681 159.298 154.226 158.22 154.226H88.1746C86.0815 154.226 84.3861 155.903 84.3861 157.975V198.501C84.3861 199.361 84.6791 200.158 85.171 200.79L160.972 155.406Z",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110.662 220.302H135.742C136.78 220.302 137.627 221.148 137.627 222.186V224.836H108.788V222.186C108.788 221.148 109.634 220.302 110.672 220.302H110.662Z",
    fill: "url(#paint27_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M135.742 220.302H123.308C124.346 220.302 125.192 221.148 125.192 222.186V224.836H137.627V222.186C137.627 221.148 136.78 220.302 135.742 220.302Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M118.008 221.531C118.008 222.146 114.602 222.287 112.163 222.287C110.007 222.287 109.664 221.954 109.664 221.531C109.664 221.108 110.148 220.775 112.163 220.775C114.592 220.775 118.008 220.906 118.008 221.531Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M120.617 221.531C120.617 221.783 120.134 221.954 119.61 221.954C119.086 221.954 118.713 221.762 118.713 221.531C118.713 221.299 119.086 221.107 119.61 221.107C120.134 221.107 120.617 221.279 120.617 221.531Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M137.617 223.989H108.777V224.826H137.617V223.989Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M163.856 205.177H82.5481V206.265H163.856V205.177Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M159.16 209.116C159.16 209.973 158.465 210.668 157.608 210.668C156.752 210.668 156.057 209.973 156.057 209.116C156.057 208.26 156.752 207.564 157.608 207.564C158.465 207.564 159.16 208.26 159.16 209.116Z",
    fill: "#463332"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M157.608 210.144C158.176 210.144 158.636 209.684 158.636 209.117C158.636 208.549 158.176 208.089 157.608 208.089C157.041 208.089 156.581 208.549 156.581 209.117C156.581 209.684 157.041 210.144 157.608 210.144Z",
    fill: "url(#paint28_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10322_11211",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 122,
    y: 153,
    width: 76,
    height: 72
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M125.704 153.541H193.72C195.753 153.541 197.401 155.189 197.401 157.223V220.826C197.401 222.86 195.753 224.508 193.72 224.508H125.704C123.67 224.508 122.022 222.86 122.022 220.826V157.223C122.022 155.189 123.67 153.541 125.704 153.541Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10322_11211)"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M179.625 187.982C184.379 191.197 191.46 204.005 192.629 211.388C193.797 218.771 188.898 227.839 188.898 227.839H179.869C179.869 227.839 182.353 217.544 182.645 213.677C182.937 209.81 176.372 203.07 176.372 203.07L179.625 187.982Z",
    fill: "url(#paint29_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M180.522 225.054C180.609 224.664 180.707 224.245 180.804 223.807C180.814 223.758 180.823 223.71 180.833 223.661C181.028 222.775 181.242 221.801 181.447 220.817C181.476 220.7 181.496 220.573 181.525 220.456C181.603 220.096 181.671 219.736 181.739 219.375C181.768 219.229 181.797 219.083 181.827 218.937C181.914 218.479 182.002 218.021 182.08 217.583C182.08 217.564 182.08 217.554 182.08 217.534C182.158 217.086 182.236 216.648 182.304 216.229C182.323 216.112 182.343 215.995 182.362 215.878C182.411 215.577 182.45 215.284 182.489 215.002C182.509 214.895 182.518 214.778 182.538 214.671C182.586 214.31 182.625 213.969 182.645 213.677C182.664 213.404 182.645 213.112 182.596 212.81C182.586 212.732 182.567 212.645 182.557 212.567C182.509 212.314 182.44 212.051 182.353 211.778C182.333 211.729 182.323 211.68 182.304 211.622C182.197 211.31 182.06 210.979 181.914 210.658C181.875 210.57 181.827 210.482 181.788 210.395C181.661 210.132 181.525 209.869 181.379 209.606C181.34 209.528 181.291 209.45 181.252 209.372C181.067 209.051 180.862 208.719 180.658 208.398C180.609 208.32 180.56 208.252 180.512 208.174C179.82 207.132 179.06 206.148 178.388 205.32L180.541 206.216L181.612 201.122C181.875 206.216 186.336 214.973 189.94 214.885C193.359 214.797 192.707 211.866 192.658 211.437C193.788 218.81 188.918 227.82 188.918 227.82H179.888C179.888 227.82 180.161 226.68 180.531 225.034L180.522 225.054Z",
    fill: "#463332"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M132.716 181.661C133.554 181.379 135.171 182.411 135.152 182.392C135.015 183.707 134.762 184.827 134.187 185.382C133.778 185.031 134.031 183.892 133.749 183.697C133.457 183.492 133.242 183.424 133.048 183.492C132.882 183.551 132.405 184.028 131.937 184.583C131.801 184.749 131.655 186.629 130.866 186.356C130.554 186.249 130.447 184.174 130.807 183.697C131.479 182.772 132.307 181.788 132.726 181.652L132.716 181.661Z",
    fill: "url(#paint30_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M132.716 181.661C133.554 181.379 135.171 182.411 135.152 182.392C135.015 183.707 134.762 184.827 134.187 185.382C133.778 185.031 134.031 183.892 133.749 183.697C133.457 183.492 133.242 183.424 133.048 183.492C132.882 183.551 132.405 184.028 131.937 184.583C131.801 184.749 131.655 186.629 130.866 186.356C130.554 186.249 130.447 184.174 130.807 183.697C131.479 182.772 132.307 181.788 132.726 181.652L132.716 181.661Z",
    fill: "#C3694D"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M135.707 205.174C134.782 201.765 134.09 189.755 134.09 189.755L137.499 188.382C137.499 188.382 140.333 197.684 141.824 203.762C141.824 203.762 136.642 208.593 135.717 205.184L135.707 205.174Z",
    fill: "url(#paint31_linear_10322_11211)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M137.499 188.382C137.07 186.541 136.759 182.859 136.262 179.314C135.911 176.83 135.21 175.174 134.908 175.301C134.294 175.564 134.528 176.849 134.82 179.275C134.918 180.064 134.947 181.155 134.957 181.671C134.957 181.671 133.467 180.668 132.668 180.94C132.191 181.096 131.168 182.304 130.515 183.346C130.301 183.882 129.902 185.275 130.135 185.45C130.652 185.83 131.343 184.544 131.548 184.213C132.191 183.599 132.804 182.849 132.999 182.781C133.379 182.645 134.343 183.405 134.421 183.707C134.519 184.057 134.324 184.515 133.963 185.041C133.291 186.025 132.103 186.95 131.996 187.359C132.463 188.45 134.002 189.629 134.324 189.979C135.678 190.194 137.499 188.382 137.499 188.382Z",
    fill: "url(#paint32_linear_10322_11211)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M132.346 187.973C131.889 187.291 131.411 186.288 130.837 185.246C130.204 184.116 129.522 183.249 129.639 182.869C129.863 182.129 131.129 182.947 132.044 184.145C133.009 185.411 133.876 185.08 133.876 185.08C133.876 185.08 134.265 186.707 133.837 187.681C133.408 188.655 132.356 187.973 132.356 187.973H132.346Z",
    fill: "url(#paint33_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M132.347 187.973C132.347 187.964 132.327 187.954 132.327 187.934C132.239 187.808 132.152 187.681 132.084 187.545C131.704 186.902 131.304 186.084 130.837 185.246C130.837 185.246 130.837 185.236 130.837 185.227L130.243 184.223C129.863 183.6 129.571 183.123 129.658 182.869C129.707 182.723 129.785 182.645 129.902 182.606C129.931 183.181 130.915 184.321 131.548 185.373C132.308 186.629 133.389 188.538 135.21 189.561L136.038 193.71L134.392 193.778C134.226 191.441 134.129 189.756 134.129 189.756C133.7 189.376 132.902 188.694 132.385 187.973H132.347Z",
    fill: "#C3694D"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M155.557 187.885C152.217 189.823 144.142 204.248 144.142 204.248L138.785 190.096L132.873 193.602C132.873 193.602 133.886 215.985 143.791 216.794C151.35 217.407 156.454 205.018 156.454 205.018L155.557 187.895V187.885Z",
    fill: "url(#paint34_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M134.236 192.784C134.762 198.56 137.285 214.68 144.551 214.797C150.999 214.904 153.337 203.138 153.337 203.138L155.645 206.713C153.941 210.083 149.596 217.261 143.791 216.794C133.876 215.985 132.872 193.602 132.872 193.602L134.236 192.794V192.784Z",
    fill: "#463332"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M172.203 183.434C171.726 182.606 165.171 182.284 163.564 184.037C161.957 185.791 166.71 187.252 166.71 187.252C166.71 187.252 173.168 185.089 172.203 183.434Z",
    fill: "#EDD3BE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M162.171 185.392C162.171 185.392 157.515 186.473 155.811 187.71C154.009 189.015 153.142 193.924 153.132 200.538C153.113 209.119 154.301 220.33 153.629 227.83H180.999C180.999 227.83 180.57 215.06 181.369 204.541C182.294 192.288 181.106 189.814 180.064 188.392C179.022 186.969 173.294 185.918 173.294 185.918L162.171 185.372V185.392Z",
    fill: "url(#paint35_linear_10322_11211)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M171.395 180.005C171.395 180.005 175.174 177.998 175.797 171.833C176.392 165.92 175.418 164.518 173.362 163.446C171.823 162.638 168.064 165.462 168.064 165.462L171.395 180.014V180.005Z",
    fill: "url(#paint36_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M168.414 166.7C168.414 166.7 171.103 168.55 174.035 167.43C175.35 166.924 175.32 165.755 174.931 164.635C175.866 165.794 176.216 167.722 175.798 171.823C175.174 177.989 171.395 179.995 171.395 179.995L168.414 166.972V166.69V166.7Z",
    fill: "#491D17"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M172.632 176.46C172.632 176.46 170.869 181.895 172.135 185.635C172.418 186.57 165.882 186.337 163.398 185.246C163.398 185.246 164.051 184.72 164.148 182.012C164.197 180.775 172.622 176.46 172.622 176.46H172.632Z",
    fill: "url(#paint37_linear_10322_11211)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M163.496 185.147C163.496 185.147 163.213 185.225 162.531 185.333C162.531 185.333 162.531 188.089 166.427 188.449C171.113 188.888 173.363 185.985 173.363 185.985L171.522 185.527L163.496 185.147Z",
    fill: "url(#paint38_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M169.963 188.1C166.603 186.901 164.626 185.051 163.876 184.223C164.002 183.736 164.119 183.025 164.158 182.012C164.207 180.775 172.632 176.46 172.632 176.46C172.632 176.46 170.869 181.895 172.135 185.635L173.363 185.986C173.363 185.986 172.252 187.359 169.953 188.09L169.963 188.1Z",
    fill: "#AC6B53"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M172.651 172.534C174.132 172.232 174.921 174.131 174.453 175.31C173.976 176.528 172.612 177.229 171.541 177.053C171.035 176.381 171.687 172.972 172.651 172.534Z",
    fill: "url(#paint39_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M172.749 173.732C173.548 173.635 173.898 174.648 173.616 175.242C173.324 175.855 172.583 176.167 172.018 176.031C171.921 175.904 172.398 173.849 172.749 173.732Z",
    fill: "#E48665"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M172.651 172.534C174.132 172.232 174.921 174.131 174.453 175.31C173.976 176.528 172.612 177.229 171.541 177.053C171.035 176.381 171.687 172.972 172.651 172.534Z",
    fill: "#E48665"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M171.853 171.405C171.736 168.755 170.713 165.999 166.613 165.035C162.044 163.963 159.142 166.028 158.587 169.038C158.402 170.022 158.421 172.272 158.967 176.041C159.493 179.655 160.622 183.999 164.499 184.272C166.096 184.379 170.606 183.58 171.502 177.21C171.502 177.21 172.048 175.72 171.863 171.405H171.853Z",
    fill: "url(#paint40_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M169.71 177.483C170.197 171.746 168.921 167.061 168.921 167.061L171.171 168.356C171.629 169.311 171.814 170.372 171.853 171.405C172.048 175.71 171.492 177.21 171.492 177.21C170.586 183.58 166.087 184.388 164.489 184.272C166.622 183.94 169.311 182.187 169.71 177.483Z",
    fill: "#E48665"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M166.544 165.385C171.492 167.391 170.061 174.677 171.21 174.774C171.872 174.833 172.379 173.118 172.369 171.735C172.359 169.904 171.999 167.099 170.528 165.833C169.944 165.326 167.138 165.141 166.544 165.385Z",
    fill: "url(#paint41_linear_10322_11211)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M169.7 168.57C169.7 168.57 168.171 164.372 162.658 165.21C158.246 165.872 158.509 170.557 158.509 170.557C156.746 169.534 155.927 164.216 157.797 161.879C159.853 159.317 158.625 163.486 162.707 161.392C167.674 158.859 173.119 160.096 173.82 163.914L169.7 168.57Z",
    fill: "url(#paint42_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M171.755 167.781C172.223 169.096 172.359 170.518 172.369 171.735C172.379 173.118 171.872 174.823 171.21 174.774C170.255 174.696 171.093 169.631 168.531 166.777C168.892 166.992 169.895 167.781 171.755 167.79V167.781Z",
    fill: "#491D17"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M167.655 186.667L166.593 188.489L165.833 186.57L163.622 187.525L162.229 185.362L160.554 185.81C161.353 190.31 163.009 195.882 165.892 198.677C171.239 194.771 173.587 189.872 174.979 186.317C174.473 186.161 173.927 186.044 173.353 185.947L167.655 186.677V186.667Z",
    fill: "#EDD3BE"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M173.655 185.956C173.655 185.956 173.148 189.151 168.561 191.216L167.567 186.667L173.655 185.956Z",
    fill: "#ECD2BD"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M165.853 190.329L167.45 190.378L168.258 197.878C167.499 198.579 166.68 199.251 165.784 199.913C165.278 199.426 164.81 198.862 164.372 198.238L165.853 190.339V190.329Z",
    fill: "url(#paint43_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M165.268 199.358C164.957 199.008 164.655 198.638 164.372 198.238L165.853 190.339L167.45 190.388L167.548 191.313C166.525 191.702 165.434 195.102 165.268 199.368V199.358Z",
    fill: "#822E50"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M168.989 186.92C168.989 186.92 168.005 188.264 166.69 188.167C165.376 188.069 164.528 186.969 164.528 186.969L163.963 188.001C163.963 188.001 164.859 189.384 166.544 189.433C168.239 189.482 169.457 188.05 169.457 188.05L168.989 186.92Z",
    fill: "url(#paint44_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M168.989 186.92C168.989 186.92 168.005 188.264 166.69 188.167C165.376 188.069 164.528 186.969 164.528 186.969L163.963 188.001C163.963 188.001 164.859 189.384 166.544 189.433C168.239 189.482 169.457 188.05 169.457 188.05L168.989 186.92Z",
    fill: "#822E50"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M167.976 187.864C167.703 187.572 165.677 187.553 165.444 187.864C165.2 188.176 165.638 190.202 165.775 190.348C165.911 190.494 167.372 190.523 167.528 190.397C167.684 190.26 168.249 188.166 167.976 187.874V187.864Z",
    fill: "url(#paint45_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M165.443 187.865C165.531 187.748 165.862 187.68 166.262 187.65C166.116 187.855 166.018 188.098 166.018 188.371C166.018 189.072 166.564 189.628 167.245 189.628C167.469 189.628 167.674 189.55 167.859 189.433C167.742 189.91 167.606 190.319 167.538 190.378C167.382 190.514 165.931 190.475 165.784 190.329C165.638 190.183 165.21 188.157 165.453 187.845L165.443 187.865Z",
    fill: "#822E50"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M165.862 186.647L164.879 191.206C164.879 191.206 161.723 188.975 162.132 185.488L165.862 186.647Z",
    fill: "#ECD2BD"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M172.203 183.434C172.203 183.434 170.84 185.869 167.645 186.677L168.726 190.252C170.947 189.453 173.002 187.534 173.655 185.966L172.203 183.443V183.434Z",
    fill: "#FFE6D6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M165.823 186.57L164.801 190.242C164.801 190.242 161.927 187.222 162.151 185.284L163.515 184.105C163.515 184.105 164.012 185.615 165.814 186.57H165.823Z",
    fill: "#FFE6D6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M157.798 161.878C158.363 161.177 158.674 160.992 158.918 161.031C157.768 161.547 157.155 164.499 158.343 164.8C159.395 165.063 159.619 163.875 161.635 163.437C164.947 162.716 168.093 166.515 171.132 165.015C173.207 163.992 172.671 162.073 171.619 160.943C172.778 161.596 173.596 162.599 173.84 163.924C173.177 165.278 171.716 166.32 168.278 166.602C167.207 165.648 165.444 164.8 162.668 165.219C158.255 165.882 158.518 170.567 158.518 170.567C156.755 169.544 155.937 164.226 157.807 161.888L157.798 161.878Z",
    fill: "#491D17"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M165.512 175.963C166.164 175.963 166.778 175.71 167.245 175.242C167.713 174.784 167.966 174.161 167.966 173.508C167.966 172.856 167.713 172.242 167.245 171.774C166.788 171.307 166.174 171.054 165.512 171.054C164.158 171.054 163.067 172.154 163.057 173.499C163.057 174.151 163.31 174.765 163.778 175.232C164.236 175.7 164.859 175.953 165.512 175.953V175.963ZM165.512 171.434C166.067 171.434 166.583 171.648 166.982 172.047C167.372 172.437 167.586 172.963 167.586 173.518C167.586 174.073 167.372 174.589 166.973 174.989C166.583 175.378 166.057 175.593 165.512 175.593C164.956 175.593 164.44 175.378 164.041 174.979C163.651 174.589 163.437 174.063 163.437 173.508C163.437 172.359 164.372 171.434 165.512 171.434Z",
    fill: "#423333"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M159.775 176.596C159.863 176.596 159.96 176.596 160.057 176.577C161.129 176.401 161.82 175.213 161.616 173.937C161.402 172.661 160.369 171.765 159.288 171.95C158.216 172.125 157.525 173.314 157.729 174.59C157.827 175.203 158.129 175.749 158.557 176.119C158.918 176.43 159.346 176.596 159.775 176.596ZM159.561 172.301C160.35 172.301 161.08 173.021 161.246 173.995C161.421 175.067 160.866 176.06 159.999 176.206C159.59 176.275 159.161 176.138 158.811 175.836C158.45 175.515 158.197 175.057 158.109 174.531C157.934 173.46 158.489 172.466 159.356 172.32C159.424 172.31 159.502 172.301 159.57 172.301H159.561Z",
    fill: "#423333"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M167.762 173.46C167.762 173.46 167.772 173.46 167.781 173.46L172.34 172.934C172.437 172.924 172.505 172.836 172.496 172.729C172.486 172.632 172.398 172.563 172.291 172.573L167.733 173.099C167.635 173.109 167.567 173.197 167.577 173.304C167.586 173.391 167.664 173.46 167.752 173.46H167.762Z",
    fill: "#423333"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M161.547 174.317C161.596 174.317 161.645 174.297 161.684 174.248C162.317 173.44 163.155 173.976 163.184 173.995C163.262 174.044 163.369 174.024 163.418 173.947C163.466 173.869 163.447 173.761 163.369 173.713C162.979 173.46 162.073 173.206 161.411 174.044C161.353 174.122 161.362 174.219 161.44 174.278C161.47 174.297 161.508 174.317 161.547 174.317Z",
    fill: "#423333"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M166.242 199.67L163.164 200.664C161.158 199.3 158.879 197.011 158.703 196.261C158.499 195.384 159.512 194.031 159.512 194.031C159.512 194.031 157.69 193.962 157.145 193.086C156.765 192.462 156.94 189.005 157.087 187.027C158.07 186.589 159.259 186.199 160.242 185.917C161.411 191.897 163.281 196.583 166.233 199.68L166.242 199.67Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M153.151 202.817C156.492 205.992 161.849 206.947 167.752 206.528C173.694 206.099 178.768 204.375 181.612 200.713C181.554 201.872 181.486 203.138 181.379 204.551C180.58 215.07 181.009 227.839 181.009 227.839H153.638C154.252 220.973 153.298 211.028 153.161 202.817H153.151Z",
    fill: "#463332"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M138.424 190.281L133.243 193.407L133.106 191.508L137.957 188.937L138.424 190.281Z",
    fill: "#EDD3BE"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M163.233 201.541C163.145 201.054 163.096 200.752 163.096 200.752L163.34 200.576C167.236 199.768 174.843 192.385 175.437 186.404C176.265 186.609 177.21 186.882 178.047 187.203C178.106 188.44 178.174 192.872 176.216 195.102L173.596 195.287C173.596 195.287 174.59 197.196 174.336 197.693C174.083 198.19 168.249 202.076 163.233 201.531V201.541Z",
    fill: "#463332"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M174.999 186.093L177.346 186.804C177.346 186.804 177.804 192.161 175.622 194.645L173.09 194.956C173.09 194.956 174.083 196.641 173.84 197.119C173.596 197.596 167.908 201.385 163.096 200.762L165.911 198.706C170.187 195.268 173.324 191.148 174.989 186.093H174.999Z",
    fill: "#665050"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M160.486 185.596L158.07 186.55C158.07 186.55 157.564 192.229 158.031 192.998C158.499 193.758 160.087 193.816 160.087 193.816C160.087 193.816 159.21 194.985 159.385 195.755C159.561 196.514 162.229 199.096 164.1 200.089L165.921 198.716C163.164 195.833 161.489 191.362 160.496 185.605L160.486 185.596Z",
    fill: "#665050"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M165.901 198.706L163.096 200.761C163.096 200.761 164.304 211.426 164.333 217.67C164.363 223.913 164.08 227.78 164.08 227.78H163.466C163.466 227.78 163.817 221.011 163.807 217.758C163.807 214.504 162.522 200.293 162.522 200.293L165.473 198.219L165.901 198.706Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M168.726 214.553C168.08 214.553 167.557 214.03 167.557 213.385C167.557 212.739 168.08 212.216 168.726 212.216C169.371 212.216 169.895 212.739 169.895 213.385C169.895 214.03 169.371 214.553 168.726 214.553Z",
    fill: "#463332"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M167.879 213.229C167.879 213.784 168.327 214.242 168.892 214.242C169.457 214.242 169.905 213.794 169.905 213.229C169.905 212.664 169.457 212.216 168.892 212.216C168.327 212.216 167.879 212.664 167.879 213.229Z",
    fill: "#665050"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M168.872 222.199C168.227 222.199 167.703 221.676 167.703 221.03C167.703 220.385 168.227 219.861 168.872 219.861C169.518 219.861 170.041 220.385 170.041 221.03C170.041 221.676 169.518 222.199 168.872 222.199Z",
    fill: "#463332"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M168.015 220.874C168.015 221.43 168.463 221.887 169.028 221.887C169.593 221.887 170.041 221.439 170.041 220.874C170.041 220.309 169.593 219.861 169.028 219.861C168.463 219.861 168.015 220.309 168.015 220.874Z",
    fill: "#665050"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M179.012 207.549L171.132 207.569L171.103 202.543L178.983 202.523L179.012 207.549Z",
    fill: "#463332"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M178.369 206.897L171.064 206.926L171.044 202.572L178.34 202.553L178.369 206.897Z",
    fill: "#FFE6D6"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M175.817 201.511L173.557 201.52L173.567 202.563L175.817 202.553V201.511Z",
    fill: "#847070"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M177.892 206.293H175.388L175.369 203.138L177.872 203.128L177.892 206.293Z",
    fill: "#DDC4B6"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M174.96 204.93L171.551 204.94V204.238L174.96 204.229V204.93Z",
    fill: "#DDC4B6"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M174.96 203.81L171.551 203.82L171.541 203.147L174.95 203.138L174.96 203.81Z",
    fill: "#DDC4B6"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M174.97 205.68L171.56 205.689L171.551 205.329L174.96 205.319L174.97 205.68Z",
    fill: "#DDC4B6"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M100.484 246.751H72.2234C59.7544 240.343 57.0486 197.635 73.426 193.869C89.8034 190.103 92.2402 212.525 97.636 214.693C102.051 216.465 107.51 216.607 109.013 222.098C110.516 227.605 109.757 241.023 100.468 246.751H100.484Z",
    fill: "url(#paint46_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5051 193.868C73.5051 193.868 73.5526 193.868 73.5842 193.853C68.9162 198.774 66.0047 205.768 66.0047 213.521C66.0047 228.395 76.7173 240.453 89.93 240.453C98.1266 240.453 105.374 235.817 109.678 228.728C109.393 234.931 107.083 242.732 100.563 246.751H72.3025C59.8335 240.342 57.0169 197.761 73.5051 193.868Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M80.151 195.498C90.9585 195.498 92.8098 212.746 97.6518 214.692C100.057 215.657 102.779 216.132 104.994 217.255C104.962 217.793 104.867 218.221 104.677 218.521C101.829 223.173 102.13 226.939 102.13 226.939H79.249C73.9481 226.939 70.4511 219.471 70.546 211.812C70.641 203.758 73.7424 195.498 80.1668 195.498H80.151Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M108.08 236.767C107.383 238.745 106.434 240.659 105.168 242.384C100.469 234.979 100.089 226.845 100.089 226.845L103.269 226.244L108.08 236.767Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M100.737 246.577C100.658 246.624 100.579 246.703 100.5 246.751H94.8353C92.7149 237.557 93.6643 226.734 93.6643 226.734L97.1613 226.133L100.722 246.577H100.737Z",
    fill: "#AA2424"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1918 184.596C77.1918 189.011 75.0872 192.682 75.9892 196.448C76.638 199.17 79.7394 199.597 79.7394 199.597C79.7394 199.597 91.7495 200.8 92.4299 195.768C93.1103 190.736 89.8981 188.41 89.5975 184.359C89.2968 180.308 77.1918 182.144 77.1918 184.612V184.596Z",
    fill: "url(#paint47_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1918 184.596C77.1918 189.011 75.0872 192.682 75.9892 196.448C76.638 199.17 79.7394 199.597 79.7394 199.597C79.7394 199.597 91.7495 200.8 92.4299 195.768C93.1103 190.736 89.8981 188.41 89.5975 184.359C89.2968 180.308 77.1918 182.144 77.1918 184.612V184.596Z",
    fill: "#491D17"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M103.744 218.363C102.684 218.015 93.9015 216.749 93.9015 216.749L91.6862 217.778L93.4268 226.971H102.858L103.744 218.379V218.363Z",
    fill: "url(#paint48_linear_10322_11211)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M108.079 224.202C110.168 232.178 113.839 244.504 113.839 244.504C112.7 244.884 111.513 245.09 110.184 244.504C110.184 244.504 106.734 238.681 103.475 230.342C102.019 226.639 99.7404 220.832 101.972 218.791C103.506 217.382 106.687 218.917 108.079 224.202Z",
    fill: "url(#paint49_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7338 218.047L91.9553 217.635L93.8858 216.749C93.8858 216.749 101.956 217.904 103.554 218.316C104.741 218.474 106.117 219.566 107.162 221.718C106.608 221.085 105.722 220.04 104.583 220.42C102.367 221.164 103.253 228.158 105.516 233.459C107.51 238.158 111.545 243.649 112.447 244.836C111.735 244.931 110.975 244.867 110.184 244.504C110.184 244.504 106.735 238.68 103.475 230.341C103.079 229.329 102.62 228.174 102.209 226.955H94.5187L92.8256 223.838L91.718 218.047H91.7338Z",
    fill: "#334B72"
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9546 217.288H89.3445L89.3128 216.924C89.3128 216.924 96.3701 217.889 97.3987 218.617L93.9016 226.956H79.2174C76.5116 224.883 76.021 220.263 76.9388 217.288H76.9546Z",
    fill: "url(#paint50_linear_10322_11211)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M100.168 224.282C100.69 233.554 102.019 244.504 102.019 244.504C100.864 245.026 99.4872 245.105 98.3637 244.504C98.3637 244.504 95.737 238.681 94.2337 230.295C93.49 226.133 92.4299 221.101 94.835 219.012C96.7655 217.335 99.8669 218.759 100.168 224.282Z",
    fill: "url(#paint51_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9544 217.288H89.3442L89.3126 216.924C89.3126 216.924 95.1515 217.731 96.987 218.411C98.5061 218.744 99.9618 220.595 100.168 224.282C100.215 225.136 100.262 226.007 100.326 226.893V226.94C99.946 223.411 99.946 220.215 96.4806 220.104C91.6703 219.962 85.7364 221.054 85.7364 223.016C85.7364 224.978 94.1546 224.693 95.0565 225.437C95.9426 226.181 94.4236 235.944 100.12 244.916C99.5188 244.916 98.9175 244.789 98.3636 244.504C98.3636 244.504 95.7369 238.681 94.2337 230.295C94.0438 229.219 93.8223 228.079 93.664 226.956H79.2488C76.5429 224.883 76.0524 220.263 76.9702 217.288H76.9544Z",
    fill: "#334B72"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M100.342 204.202C101.101 202.604 102.114 197.303 102.351 196.511C102.636 195.499 100.563 195.736 100.563 195.736C100.421 196.527 98.7435 200.119 97.4776 202.967C97.4776 202.967 99.598 205.8 100.358 204.202H100.342Z",
    fill: "url(#paint52_linear_10322_11211)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M100.547 195.736C100.816 194.486 101.687 192.429 102.541 192.366C103.048 192.334 103.712 193.996 103.538 194.439C103.19 195.356 102.573 195.973 102.383 196.432C102.193 196.907 100.547 195.736 100.547 195.736Z",
    fill: "url(#paint53_linear_10322_11211)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8821 194.628C87.936 201.812 91.8286 210.357 95.8004 210.99C98.4113 211.401 101.623 209.613 102.351 198.584L99.3607 196.194L96.0377 204.977C94.7402 204.818 93.5376 196.891 91.0691 194.391C89.9773 193.283 84.8821 194.628 84.8821 194.628Z",
    fill: "url(#paint54_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4551 196.194C91.3223 205.704 94.7876 208.98 96.2118 209.027C98.7277 209.106 101.133 207.398 102.351 198.584C101.623 209.613 98.4113 211.401 95.8004 210.99C91.8286 210.357 87.936 201.812 84.8821 194.628C84.8821 194.628 89.0753 196.289 89.4551 196.194Z",
    fill: "#A0335D"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1924 175.292C87.1924 175.292 88.395 174.516 89.8983 175.687C91.9553 177.286 91.0059 179.707 91.2907 181.415L87.8887 177.729L87.1924 175.276V175.292Z",
    fill: "url(#paint55_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8887 177.745L91.2907 181.431C91.085 180.245 91.4806 178.71 91.0692 177.365C90.816 177.555 90.4521 177.539 89.74 177.064C88.9963 176.558 88.3792 175.767 88.3792 175.767L87.6355 176.858L87.8887 177.76V177.745Z",
    fill: "#491D17"
  }))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8121 217.714C78.5844 212.366 81.6383 211.021 81.3852 207.302C81.1953 204.549 77.4134 201.068 78.6318 196.099C79.5654 192.317 83.1732 192.428 86.3379 192.333C87.6038 192.302 88.8855 192.602 89.9457 193.299C92.3034 194.865 94.1864 199.786 93.5851 201.922C92.968 204.122 91.5439 204.248 91.5439 207.524C91.5439 210.261 92.8889 212.936 93.9016 216.86C94.0756 218.347 82.5403 220.911 76.8121 217.714Z",
    fill: "url(#paint56_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3853 207.302C81.1954 204.549 77.4136 201.068 78.632 196.099C78.8377 195.292 79.1542 194.675 79.5656 194.185C79.3599 195.973 79.7238 197.871 80.7207 199.565C83.5215 204.28 91.8447 205.973 93.6644 201.321C93.6486 201.543 93.6169 201.748 93.5695 201.938C92.9523 204.138 91.5282 204.264 91.5282 207.54C91.5282 210.277 92.8732 212.951 93.8859 216.876C94.06 218.363 82.5246 220.926 76.7965 217.73C78.5687 212.382 81.6227 211.037 81.3695 207.318L81.3853 207.302Z",
    fill: "#A0335D"
  }))), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5085 192.618L81.8597 192.777C82.461 194.486 84.7238 197.223 87.6986 196.843C90.1196 196.543 89.6766 194.217 88.9803 192.777L88.1733 192.444L82.5085 192.603V192.618Z",
    fill: "url(#paint57_linear_10322_11211)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9199 185.118C83.2522 186.511 83.363 187.666 83.4737 189.296C83.632 191.59 82.4294 192.713 82.4294 192.713C83.901 193.093 86.6068 193.251 88.1891 192.46C88.1891 192.46 86.9707 192.16 87.4455 189.027C87.7619 186.875 82.9357 185.118 82.9357 185.118H82.9199Z",
    fill: "url(#paint58_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9929 196.337C83.8536 195.751 82.9516 194.77 82.3978 193.853C82.2079 193.536 82.0655 193.251 81.9547 192.982C81.9547 192.982 81.9073 192.856 81.8756 192.792L82.5244 192.634C82.5244 192.634 82.6668 192.46 82.7617 192.333C82.7617 192.333 82.7617 192.333 82.7617 192.318C83.0782 191.827 83.5213 190.925 83.4738 189.58C83.4738 189.501 83.4738 189.406 83.4738 189.327C83.4738 189.248 83.4738 189.185 83.4738 189.121C83.3947 188.093 83.3156 187.238 83.1732 186.384L87.3664 188.378C87.4455 188.599 87.4772 188.836 87.4455 189.058C86.9866 192.207 88.1892 192.492 88.1892 192.492L88.3633 192.571C87.9202 193.362 86.7651 195.198 84.9929 196.368V196.337Z",
    fill: "#AC6B53"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1256 187.935C85.0719 190.704 88.648 191.1 89.1702 190.941C89.6924 190.783 92.6988 187.27 91.4963 183.362C91.3538 182.84 91.2273 180.165 90.5468 179.042C88.8695 176.273 86.5276 176.241 84.2965 177.032C80.7837 178.282 80.6729 181.479 81.8439 184.96C81.8439 184.96 82.2869 186.748 83.1256 187.935Z",
    fill: "url(#paint59_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9516 182.429L81.6066 184.138C81.6857 184.407 81.749 184.691 81.8439 184.976C81.8439 184.976 82.287 186.764 83.1256 187.951C85.0719 190.72 88.648 191.116 89.1702 190.958C83.1573 190.293 82.9516 182.429 82.9516 182.429Z",
    fill: "#E38565"
  }))), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6542 184.058C80.594 183.931 80.1035 185.292 80.4832 186.083C80.8788 186.906 81.9548 187.318 82.6985 187.144C83.0308 186.653 82.3504 184.311 81.6542 184.058Z",
    fill: "url(#paint60_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6542 184.058C80.594 183.931 80.1035 185.292 80.4833 186.083C80.8788 186.906 81.9549 187.334 82.6986 187.159C83.0309 186.669 82.3505 184.311 81.6384 184.058H81.6542Z",
    fill: "#E38565"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6225 184.897C81.0528 184.865 80.8471 185.593 81.0686 185.988C81.306 186.4 81.844 186.574 82.2396 186.463C82.3029 186.368 81.9706 185.878 81.6225 184.897Z",
    fill: "#AC6B53"
  }))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7774 183.631C82.7457 184.454 82.9514 185.166 82.3343 185.308C81.7172 185.435 81.3532 184.042 81.3532 184.042L82.7774 183.647V183.631Z",
    fill: "url(#paint61_linear_10322_11211)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6957 176.605C88.8381 178.457 86.0531 179.438 84.6923 180.371C82.5878 181.811 82.7777 184.232 82.7777 184.232L81.4327 184.011C81.4327 184.011 78.0306 184.849 77.1919 184.612C76.6697 179.327 78.1572 175.956 82.841 174.485C86.781 173.251 88.5849 175.165 88.6957 176.621V176.605Z",
    fill: "url(#paint62_linear_10322_11211)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M103.017 195.989C103.095 196.115 103.142 196.115 103.111 195.989H103.017Z",
    fill: "#7E8082"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M103 195.989C102.715 195.736 101.924 194.328 101.054 192.555C100.073 190.546 99.2974 188.9 99.5664 188.774C99.8354 188.647 100.642 190.261 101.623 192.286C102.494 194.074 103.079 195.625 103.111 196.005H103V195.989Z",
    fill: "url(#paint63_linear_10322_11211)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M100.519 191.427L101.088 191.149L101.276 191.533L100.707 191.811L100.519 191.427Z",
    fill: "url(#paint64_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M102.826 195.42C102.652 195.214 101.924 193.727 101.291 192.413C100.563 190.926 99.788 189.359 99.8987 189.296C100.009 189.249 100.816 190.799 101.544 192.287C102.177 193.6 102.826 195.135 102.874 195.388H102.826V195.42Z",
    fill: "#A7AAAF"
  }))), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M100.505 191.413L100.747 191.295L100.934 191.679L100.692 191.797L100.505 191.413Z",
    fill: "#A69B9B"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M102.826 192.334C103 192.587 102.747 192.793 102.478 193.03C102.209 193.267 101.924 193.473 101.734 193.283C101.528 193.078 101.829 192.682 102.13 192.429C102.367 192.223 102.636 192.065 102.826 192.334Z",
    fill: "#FFB182"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M103.538 193.156C103.728 193.378 103.475 193.71 103.174 194.058C102.873 194.422 102.478 194.818 102.272 194.612C102.082 194.406 102.415 193.947 102.747 193.568C103.032 193.235 103.332 192.935 103.538 193.156Z",
    fill: "#FFB182"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M103.665 193.79C103.807 193.964 103.649 194.28 103.427 194.565C103.19 194.866 102.873 195.151 102.684 195.04C102.478 194.913 102.763 194.502 103.016 194.185C103.222 193.916 103.491 193.568 103.68 193.806L103.665 193.79Z",
    fill: "#FFB182"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M103.269 192.729C103.443 192.982 103.222 193.22 102.953 193.52C102.652 193.853 102.32 194.138 102.067 193.963C101.798 193.789 102.162 193.299 102.51 192.967C102.795 192.682 103.095 192.46 103.285 192.713L103.269 192.729Z",
    fill: "#FFB182"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1196 212.414C90.7684 212.446 92.4773 212.572 93.3001 212.683C94.123 212.794 95.6262 213.522 95.5787 213.854C95.5313 214.202 94.4078 213.411 93.49 213.269C92.5723 213.126 90.1196 212.414 90.1196 212.414Z",
    fill: "url(#paint65_linear_10322_11211)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5183 214.155C90.1196 214.518 91.0215 214.708 92.145 214.898C93.8539 215.199 94.2179 215.8 94.4394 215.452C94.6451 215.136 92.6672 214.55 92.7463 214.424C92.8096 214.297 93.5691 214.518 94.1546 214.756C94.8983 215.041 95.6103 215.436 95.7211 215.199C95.8319 214.962 95.3255 214.756 94.5185 214.36C93.759 213.98 93.126 213.87 93.126 213.727C93.126 213.585 93.9963 213.965 94.7084 214.234C95.3097 214.455 95.9585 215.009 96.1483 214.74C96.2749 214.55 95.5312 214.091 94.7717 213.711C93.4583 213.047 92.414 212.683 91.1956 212.509C90.6734 212.43 90.1354 212.414 90.1354 212.414C90.1354 212.414 90.1354 212.224 89.7398 213.063C89.3284 213.901 89.5341 214.155 89.5341 214.155H89.5183Z",
    fill: "url(#paint66_linear_10322_11211)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1197 212.414C89.4393 212.351 87.4614 211.781 87.4614 211.781L86.6385 213.807C86.6385 213.807 88.8064 213.965 89.5026 214.139C90.1988 214.313 90.1039 212.398 90.1039 212.398L90.1197 212.414Z",
    fill: "url(#paint67_linear_10322_11211)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M87.477 211.781C87.477 211.781 89.0594 212.24 89.8822 212.367C89.8031 212.746 89.6765 213.822 90.6417 214.281C91.6544 214.772 92.3348 214.851 92.857 215.041C92.6513 214.993 92.4298 214.93 92.1766 214.883C91.0531 214.677 90.1512 214.503 89.5499 214.139C88.8537 213.965 86.6858 213.807 86.6858 213.807L87.5087 211.781H87.477Z",
    fill: "#C4694D"
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M100.452 195.64C100.358 194.77 100.532 193.947 100.721 193.378C100.848 192.998 101.149 192.001 101.402 192.049C101.797 192.128 101.56 193.03 101.465 193.425C101.323 194.011 101.845 194.39 101.892 194.881C102.003 196.321 100.579 196.748 100.468 195.64H100.452Z",
    fill: "#FFB182"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0559 193.948C78.0147 193.853 73.4891 207.651 74.9766 210.578C76.6855 213.933 86.1322 214.708 88.5532 214.74C88.5532 214.74 89.9457 213.142 88.9013 211.006C88.9013 211.006 81.5592 208.331 80.7996 207.524C80.0401 206.717 85.8632 194.201 80.0718 193.948H80.0559Z",
    fill: "url(#paint68_linear_10322_11211)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M107.921 218.775V217.968C107.921 217.968 106.829 217.034 104.298 217.05C101.766 217.05 98.3005 217.066 95.8953 217.082C93.5059 217.082 92.3192 217.825 92.3192 217.825V218.806L107.921 218.775Z",
    fill: "#CEB6AA"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6485 215.863C101.623 215.784 104.661 215.863 107.367 216.069C103.886 216.069 101.592 216.654 100.421 218.094L91.6861 218.126C93.3002 216.085 98.6485 215.863 98.6485 215.863Z",
    fill: "#EDD8CA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4238 218.127L94.7086 216.481C94.9618 216.418 95.2308 216.338 95.484 216.291C96.0694 216.497 97.0188 216.75 98.2531 216.845C100.437 217.019 102.937 216.576 102.937 216.576C101.829 216.908 100.991 217.399 100.421 218.111H94.4238V218.127Z",
    fill: "#CEB6AA"
  }))), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5654 218.158L83.711 218.111V217.842C83.711 217.842 84.8819 217.098 87.2871 217.098C88.9011 217.098 91.0056 217.098 92.9836 217.082C93.6324 216.861 94.7558 216.592 96.4173 216.639C99.2814 216.718 100.199 218.095 100.199 218.095L99.313 218.063V218.807L83.7268 218.839V218.253L84.5813 218.174L84.5654 218.158Z",
    fill: "#CEB6AA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5656 218.158L83.6795 218.11V217.841L92.6198 217.81V218.806L83.6795 218.822V218.237L84.5656 218.158Z",
    fill: "#B29B93"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M108.016 218.775V217.968C108.016 217.968 106.924 217.034 104.392 217.05C101.861 217.05 100.437 218.079 100.437 218.079C100.437 218.079 98.3953 217.066 96.006 217.082C93.6166 217.082 92.4299 217.825 92.4299 217.825V218.806L108.032 218.775H108.016Z",
    fill: "#FAE7DC"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1708 218.792L108.691 218.743L108.692 219.297L92.1724 219.346L92.1708 218.792Z",
    fill: "url(#paint69_linear_10322_11211)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8984 218.82L92.2026 218.792L92.2042 219.346L82.9 219.373L82.8984 218.82Z",
    fill: "url(#paint70_linear_10322_11211)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M100.484 218.158C102.304 215.896 107.32 216.244 107.367 216.244V216.086C107.162 216.07 102.24 215.737 100.373 218.063L100.5 218.158H100.484Z",
    fill: "#FAE7DC"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8511 218.759H100.99C100.99 218.759 100.69 218.189 100.421 218.189C100.152 218.189 99.8511 218.759 99.8511 218.759Z",
    fill: "url(#paint71_linear_10322_11211)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M88.031 216.228C88.031 216.228 88.838 216.323 89.8507 216.782L98.079 217.146L100.104 217.794C100.104 217.794 98.8543 216.18 94.5029 215.896C90.6103 215.642 88.0152 216.228 88.0152 216.228H88.031Z",
    fill: "#CEB6AA"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4298 217.303L83.6952 217.193C83.6952 217.193 85.1035 216.829 87.4929 216.67C89.8822 216.512 95.5629 216.291 97.7149 216.86C97.7149 216.86 94.9932 216.449 92.4298 217.319V217.303Z",
    fill: "#EDD8CA"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M92.873 216.212L84.1384 216.148C84.1384 216.148 85.5467 215.769 87.9361 215.579C89.8982 215.421 96.1327 215.12 98.9018 216.797C98.9018 216.797 95.8637 215.626 92.8572 216.212H92.873Z",
    fill: "#EDD8CA"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M100.31 218.158L100.405 218.031C97.3509 215.658 92.6988 217.05 92.4298 217.145L83.6793 217.177V217.335L92.4614 217.303C92.4614 217.303 97.2401 215.784 100.31 218.158Z",
    fill: "#FAE7DC"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M100.294 218.142L100.421 218.047C98.3953 215.262 92.9362 216.117 92.8729 216.117L84.1224 216.148V216.307L92.8729 216.275C92.8729 216.275 98.3162 215.42 100.278 218.142H100.294Z",
    fill: "#FAE7DC"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2973 218.047C99.2973 218.047 98.9492 217.873 98.3795 217.699C97.8099 217.54 97.0345 217.398 96.2433 217.366C94.661 217.366 93.1577 217.857 93.1577 217.857C93.1577 217.857 94.6926 217.445 96.2433 217.524C97.0187 217.524 97.794 217.604 98.3637 217.746C98.9333 217.873 99.2973 218.047 99.2973 218.047Z",
    fill: "#D8C0B6"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8385 218.301C98.8385 218.301 97.8891 218.063 96.9239 218C95.9428 218 94.9776 218.127 94.9776 218.127C94.9776 218.127 95.9428 218.079 96.9081 218.158C97.8733 218.158 98.8385 218.301 98.8385 218.301Z",
    fill: "#D8C0B6"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M101.212 218.063C101.212 218.063 101.592 217.904 102.193 217.762C102.794 217.62 103.601 217.509 104.424 217.525C106.07 217.43 107.652 217.999 107.652 217.999C107.652 217.999 106.102 217.351 104.424 217.366C103.601 217.398 102.779 217.541 102.177 217.715C101.576 217.873 101.212 218.063 101.212 218.063Z",
    fill: "#D8C0B6"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M106.402 218.411C106.402 218.411 105.231 218.142 104.029 218.158C102.826 218.205 101.671 218.522 101.671 218.522C101.671 218.522 102.842 218.284 104.029 218.3C105.215 218.221 106.402 218.395 106.402 218.395V218.411Z",
    fill: "#D8C0B6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8984 218.82L92.2026 218.792L92.2042 219.346L82.9 219.373L82.8984 218.82Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8153 209.597C77.461 212.825 86.3064 213.664 89.0913 213.743C88.8698 214.36 88.5533 214.724 88.5533 214.724C86.1481 214.692 76.6856 213.917 74.9767 210.562C73.6159 207.872 77.3344 195.941 79.5339 194.153C78.6794 195.34 74.4387 206.875 75.7995 209.581L75.8153 209.597Z",
    fill: "#A0335D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3155 177.681C77.8566 178.757 77.9041 180.166 79.708 180.577C82.7936 181.289 87.6514 178.615 87.952 176.416C88.0628 175.577 87.8887 175.007 87.2874 174.58C88.1894 175.086 88.6483 175.909 88.7116 176.605C88.854 178.457 86.069 179.438 84.7082 180.372C84.2968 180.656 83.9329 181.004 83.6322 181.416C83.1258 182.112 82.8569 183.014 82.7936 183.726C82.7936 184.501 82.936 185.182 82.3505 185.293C81.7334 185.419 81.3694 184.027 81.3694 184.027L81.4644 183.995C81.3536 184.027 78.2206 184.786 77.287 184.612C77.2553 184.517 77.2236 184.407 77.192 184.296C76.9546 181.558 77.2869 179.359 78.3313 177.681H78.3155Z",
    fill: "#491D17"
  }))), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M31.14 64.24C30.1133 64.24 29.2067 64.0667 28.42 63.72C27.6333 63.36 27.0133 62.8533 26.56 62.2C26.1067 61.5333 25.8733 60.7267 25.86 59.78H28.56C28.5867 60.4333 28.82 60.9867 29.26 61.44C29.7133 61.88 30.3333 62.1 31.12 62.1C31.8 62.1 32.34 61.94 32.74 61.62C33.14 61.2867 33.34 60.8467 33.34 60.3C33.34 59.7267 33.16 59.28 32.8 58.96C32.4533 58.64 31.9867 58.38 31.4 58.18C30.8133 57.98 30.1867 57.7667 29.52 57.54C28.44 57.1667 27.6133 56.6867 27.04 56.1C26.48 55.5133 26.2 54.7333 26.2 53.76C26.1867 52.9333 26.38 52.2267 26.78 51.64C27.1933 51.04 27.7533 50.58 28.46 50.26C29.1667 49.9267 29.98 49.76 30.9 49.76C31.8333 49.76 32.6533 49.9267 33.36 50.26C34.08 50.5933 34.64 51.06 35.04 51.66C35.4533 52.26 35.6733 52.9733 35.7 53.8H32.96C32.9467 53.3067 32.7533 52.8733 32.38 52.5C32.02 52.1133 31.5133 51.92 30.86 51.92C30.3 51.9067 29.8267 52.0467 29.44 52.34C29.0667 52.62 28.88 53.0333 28.88 53.58C28.88 54.0467 29.0267 54.42 29.32 54.7C29.6133 54.9667 30.0133 55.1933 30.52 55.38C31.0267 55.5667 31.6067 55.7667 32.26 55.98C32.9533 56.22 33.5867 56.5 34.16 56.82C34.7333 57.14 35.1933 57.5667 35.54 58.1C35.8867 58.62 36.06 59.2933 36.06 60.12C36.06 60.8533 35.8733 61.5333 35.5 62.16C35.1267 62.7867 34.5733 63.2933 33.84 63.68C33.1067 64.0533 32.2067 64.24 31.14 64.24ZM42.8736 64.24C41.8603 64.24 40.9669 64.02 40.1936 63.58C39.4203 63.14 38.8069 62.5267 38.3536 61.74C37.9136 60.9533 37.6936 60.0533 37.6936 59.04C37.6936 58.0267 37.9136 57.1267 38.3536 56.34C38.8069 55.5533 39.4203 54.94 40.1936 54.5C40.9669 54.06 41.8603 53.84 42.8736 53.84C44.1403 53.84 45.2069 54.1733 46.0736 54.84C46.9403 55.4933 47.4936 56.4 47.7336 57.56H45.0336C44.9003 57.08 44.6336 56.7067 44.2336 56.44C43.8469 56.16 43.3869 56.02 42.8536 56.02C42.1469 56.02 41.5469 56.2867 41.0536 56.82C40.5603 57.3533 40.3136 58.0933 40.3136 59.04C40.3136 59.9867 40.5603 60.7267 41.0536 61.26C41.5469 61.7933 42.1469 62.06 42.8536 62.06C43.3869 62.06 43.8469 61.9267 44.2336 61.66C44.6336 61.3933 44.9003 61.0133 45.0336 60.52H47.7336C47.4936 61.64 46.9403 62.54 46.0736 63.22C45.2069 63.9 44.1403 64.24 42.8736 64.24ZM49.7858 64V49.6H52.3458V55.6C52.6791 55.0533 53.1258 54.6267 53.6858 54.32C54.2591 54 54.9124 53.84 55.6458 53.84C56.8724 53.84 57.8191 54.2267 58.4858 55C59.1658 55.7733 59.5058 56.9067 59.5058 58.4V64H56.9658V58.64C56.9658 57.7867 56.7924 57.1333 56.4458 56.68C56.1124 56.2267 55.5791 56 54.8458 56C54.1258 56 53.5258 56.2533 53.0458 56.76C52.5791 57.2667 52.3458 57.9733 52.3458 58.88V64H49.7858ZM66.4938 64.24C65.5338 64.24 64.6671 64.02 63.8938 63.58C63.1338 63.14 62.5271 62.5333 62.0738 61.76C61.6338 60.9733 61.4138 60.0667 61.4138 59.04C61.4138 58.0133 61.6404 57.1133 62.0938 56.34C62.5471 55.5533 63.1538 54.94 63.9138 54.5C64.6871 54.06 65.5538 53.84 66.5138 53.84C67.4604 53.84 68.3138 54.06 69.0738 54.5C69.8471 54.94 70.4538 55.5533 70.8938 56.34C71.3471 57.1133 71.5738 58.0133 71.5738 59.04C71.5738 60.0667 71.3471 60.9733 70.8938 61.76C70.4538 62.5333 69.8471 63.14 69.0738 63.58C68.3004 64.02 67.4404 64.24 66.4938 64.24ZM66.4938 62.02C67.1604 62.02 67.7404 61.7733 68.2338 61.28C68.7271 60.7733 68.9738 60.0267 68.9738 59.04C68.9738 58.0533 68.7271 57.3133 68.2338 56.82C67.7404 56.3133 67.1671 56.06 66.5138 56.06C65.8338 56.06 65.2471 56.3133 64.7538 56.82C64.2738 57.3133 64.0338 58.0533 64.0338 59.04C64.0338 60.0267 64.2738 60.7733 64.7538 61.28C65.2471 61.7733 65.8271 62.02 66.4938 62.02ZM78.4027 64.24C77.4427 64.24 76.576 64.02 75.8027 63.58C75.0427 63.14 74.436 62.5333 73.9827 61.76C73.5427 60.9733 73.3227 60.0667 73.3227 59.04C73.3227 58.0133 73.5493 57.1133 74.0027 56.34C74.456 55.5533 75.0627 54.94 75.8227 54.5C76.596 54.06 77.4627 53.84 78.4227 53.84C79.3693 53.84 80.2227 54.06 80.9827 54.5C81.756 54.94 82.3627 55.5533 82.8027 56.34C83.256 57.1133 83.4827 58.0133 83.4827 59.04C83.4827 60.0667 83.256 60.9733 82.8027 61.76C82.3627 62.5333 81.756 63.14 80.9827 63.58C80.2093 64.02 79.3493 64.24 78.4027 64.24ZM78.4027 62.02C79.0693 62.02 79.6493 61.7733 80.1427 61.28C80.636 60.7733 80.8827 60.0267 80.8827 59.04C80.8827 58.0533 80.636 57.3133 80.1427 56.82C79.6493 56.3133 79.076 56.06 78.4227 56.06C77.7427 56.06 77.156 56.3133 76.6627 56.82C76.1827 57.3133 75.9427 58.0533 75.9427 59.04C75.9427 60.0267 76.1827 60.7733 76.6627 61.28C77.156 61.7733 77.736 62.02 78.4027 62.02ZM85.5516 64V49.6H88.1116V64H85.5516ZM32.92 90.24C31.52 90.24 30.2933 89.9333 29.24 89.32C28.2 88.7067 27.38 87.86 26.78 86.78C26.1933 85.6867 25.9 84.4267 25.9 83C25.9 81.5733 26.1933 80.32 26.78 79.24C27.38 78.1467 28.2 77.2933 29.24 76.68C30.2933 76.0667 31.52 75.76 32.92 75.76C34.3067 75.76 35.5267 76.0667 36.58 76.68C37.6333 77.2933 38.4533 78.1467 39.04 79.24C39.6267 80.32 39.92 81.5733 39.92 83C39.92 84.4267 39.6267 85.6867 39.04 86.78C38.4533 87.86 37.6333 88.7067 36.58 89.32C35.5267 89.9333 34.3067 90.24 32.92 90.24ZM32.92 87.94C34.2533 87.94 35.3133 87.5 36.1 86.62C36.9 85.74 37.3 84.5333 37.3 83C37.3 81.4667 36.9 80.26 36.1 79.38C35.3133 78.5 34.2533 78.06 32.92 78.06C31.5867 78.06 30.52 78.5 29.72 79.38C28.92 80.26 28.52 81.4667 28.52 83C28.52 84.5333 28.92 85.74 29.72 86.62C30.52 87.5 31.5867 87.94 32.92 87.94ZM41.9003 94.4V80.08H44.1803L44.4603 81.5C44.7803 81.06 45.2003 80.6733 45.7203 80.34C46.2536 80.0067 46.9403 79.84 47.7803 79.84C48.7136 79.84 49.547 80.0667 50.2803 80.52C51.0136 80.9733 51.5936 81.5933 52.0203 82.38C52.447 83.1667 52.6603 84.06 52.6603 85.06C52.6603 86.06 52.447 86.9533 52.0203 87.74C51.5936 88.5133 51.0136 89.1267 50.2803 89.58C49.547 90.02 48.7136 90.24 47.7803 90.24C47.0336 90.24 46.3803 90.1 45.8203 89.82C45.2603 89.54 44.807 89.1467 44.4603 88.64V94.4H41.9003ZM47.2403 88C48.0536 88 48.727 87.7267 49.2603 87.18C49.7936 86.6333 50.0603 85.9267 50.0603 85.06C50.0603 84.1933 49.7936 83.48 49.2603 82.92C48.727 82.36 48.0536 82.08 47.2403 82.08C46.4136 82.08 45.7336 82.36 45.2003 82.92C44.6803 83.4667 44.4203 84.1733 44.4203 85.04C44.4203 85.9067 44.6803 86.62 45.2003 87.18C45.7336 87.7267 46.4136 88 47.2403 88ZM59.5472 90.24C58.5472 90.24 57.6605 90.0267 56.8872 89.6C56.1139 89.1733 55.5072 88.5733 55.0672 87.8C54.6272 87.0267 54.4072 86.1333 54.4072 85.12C54.4072 84.0933 54.6205 83.18 55.0472 82.38C55.4872 81.58 56.0872 80.96 56.8472 80.52C57.6205 80.0667 58.5272 79.84 59.5672 79.84C60.5405 79.84 61.4005 80.0533 62.1472 80.48C62.8939 80.9067 63.4739 81.4933 63.8872 82.24C64.3139 82.9733 64.5272 83.7933 64.5272 84.7C64.5272 84.8467 64.5205 85 64.5072 85.16C64.5072 85.32 64.5005 85.4867 64.4872 85.66H56.9472C57.0005 86.4333 57.2672 87.04 57.7472 87.48C58.2405 87.92 58.8339 88.14 59.5272 88.14C60.0472 88.14 60.4805 88.0267 60.8272 87.8C61.1872 87.56 61.4539 87.2533 61.6272 86.88H64.2272C64.0405 87.5067 63.7272 88.08 63.2872 88.6C62.8605 89.1067 62.3272 89.5067 61.6872 89.8C61.0605 90.0933 60.3472 90.24 59.5472 90.24ZM59.5672 81.92C58.9405 81.92 58.3872 82.1 57.9072 82.46C57.4272 82.8067 57.1205 83.34 56.9872 84.06H61.9272C61.8872 83.4067 61.6472 82.8867 61.2072 82.5C60.7672 82.1133 60.2205 81.92 59.5672 81.92ZM66.4603 90V80.08H68.7403L68.9803 81.94C69.3403 81.3 69.827 80.7933 70.4403 80.42C71.067 80.0333 71.8003 79.84 72.6403 79.84V82.54H71.9203C71.3603 82.54 70.8603 82.6267 70.4203 82.8C69.9803 82.9733 69.6336 83.2733 69.3803 83.7C69.1403 84.1267 69.0203 84.72 69.0203 85.48V90H66.4603ZM77.59 90.24C76.7367 90.24 76.0367 90.1067 75.49 89.84C74.9433 89.56 74.5367 89.1933 74.27 88.74C74.0033 88.2867 73.87 87.7867 73.87 87.24C73.87 86.32 74.23 85.5733 74.95 85C75.67 84.4267 76.75 84.14 78.19 84.14H80.71V83.9C80.71 83.22 80.5167 82.72 80.13 82.4C79.7433 82.08 79.2633 81.92 78.69 81.92C78.17 81.92 77.7167 82.0467 77.33 82.3C76.9433 82.54 76.7033 82.9 76.61 83.38H74.11C74.1767 82.66 74.4167 82.0333 74.83 81.5C75.2567 80.9667 75.8033 80.56 76.47 80.28C77.1367 79.9867 77.8833 79.84 78.71 79.84C80.1233 79.84 81.2367 80.1933 82.05 80.9C82.8633 81.6067 83.27 82.6067 83.27 83.9V90H81.09L80.85 88.4C80.5567 88.9333 80.1433 89.3733 79.61 89.72C79.09 90.0667 78.4167 90.24 77.59 90.24ZM78.17 88.24C78.9033 88.24 79.47 88 79.87 87.52C80.2833 87.04 80.5433 86.4467 80.65 85.74H78.47C77.79 85.74 77.3033 85.8667 77.01 86.12C76.7167 86.36 76.57 86.66 76.57 87.02C76.57 87.4067 76.7167 87.7067 77.01 87.92C77.3033 88.1333 77.69 88.24 78.17 88.24ZM89.7763 90C88.7363 90 87.9029 89.7467 87.2763 89.24C86.6496 88.7333 86.3363 87.8333 86.3363 86.54V82.22H84.6363V80.08H86.3363L86.6363 77.42H88.8963V80.08H91.5763V82.22H88.8963V86.56C88.8963 87.04 88.9963 87.3733 89.1963 87.56C89.4096 87.7333 89.7696 87.82 90.2763 87.82H91.5163V90H89.7763ZM94.9342 78.54C94.4676 78.54 94.0809 78.4 93.7742 78.12C93.4809 77.84 93.3342 77.4867 93.3342 77.06C93.3342 76.6333 93.4809 76.2867 93.7742 76.02C94.0809 75.74 94.4676 75.6 94.9342 75.6C95.4009 75.6 95.7809 75.74 96.0742 76.02C96.3809 76.2867 96.5342 76.6333 96.5342 77.06C96.5342 77.4867 96.3809 77.84 96.0742 78.12C95.7809 78.4 95.4009 78.54 94.9342 78.54ZM93.6542 90V80.08H96.2142V90H93.6542ZM98.6662 90V80.08H100.926L101.126 81.76C101.433 81.1733 101.873 80.7067 102.446 80.36C103.033 80.0133 103.72 79.84 104.506 79.84C105.733 79.84 106.686 80.2267 107.366 81C108.046 81.7733 108.386 82.9067 108.386 84.4V90H105.826V84.64C105.826 83.7867 105.653 83.1333 105.306 82.68C104.96 82.2267 104.42 82 103.686 82C102.966 82 102.373 82.2533 101.906 82.76C101.453 83.2667 101.226 83.9733 101.226 84.88V90H98.6662ZM114.814 87.04C114.334 87.04 113.888 86.9867 113.474 86.88L112.734 87.62C112.961 87.74 113.268 87.84 113.654 87.92C114.041 88 114.668 88.08 115.534 88.16C116.854 88.28 117.814 88.5933 118.414 89.1C119.014 89.6067 119.314 90.3067 119.314 91.2C119.314 91.7867 119.154 92.34 118.834 92.86C118.514 93.3933 118.021 93.82 117.354 94.14C116.688 94.4733 115.834 94.64 114.794 94.64C113.381 94.64 112.241 94.3733 111.374 93.84C110.508 93.32 110.074 92.5333 110.074 91.48C110.074 90.5867 110.508 89.8133 111.374 89.16C111.108 89.04 110.874 88.9133 110.674 88.78C110.488 88.6467 110.321 88.5067 110.174 88.36V87.9L111.914 86.06C111.141 85.38 110.754 84.5067 110.754 83.44C110.754 82.7733 110.914 82.1667 111.234 81.62C111.568 81.0733 112.034 80.64 112.634 80.32C113.234 80 113.961 79.84 114.814 79.84C115.374 79.84 115.894 79.92 116.374 80.08H120.134V81.64L118.434 81.76C118.701 82.2667 118.834 82.8267 118.834 83.44C118.834 84.1067 118.674 84.7133 118.354 85.26C118.034 85.8067 117.568 86.24 116.954 86.56C116.354 86.88 115.641 87.04 114.814 87.04ZM114.814 85.08C115.334 85.08 115.761 84.94 116.094 84.66C116.441 84.38 116.614 83.98 116.614 83.46C116.614 82.94 116.441 82.54 116.094 82.26C115.761 81.98 115.334 81.84 114.814 81.84C114.268 81.84 113.828 81.98 113.494 82.26C113.161 82.54 112.994 82.94 112.994 83.46C112.994 83.98 113.161 84.38 113.494 84.66C113.828 84.94 114.268 85.08 114.814 85.08ZM112.414 91.22C112.414 91.7133 112.641 92.08 113.094 92.32C113.561 92.5733 114.128 92.7 114.794 92.7C115.434 92.7 115.954 92.5667 116.354 92.3C116.754 92.0467 116.954 91.7 116.954 91.26C116.954 90.9 116.821 90.6 116.554 90.36C116.301 90.12 115.788 89.9733 115.014 89.92C114.468 89.88 113.961 89.82 113.494 89.74C113.108 89.9533 112.828 90.1867 112.654 90.44C112.494 90.6933 112.414 90.9533 112.414 91.22ZM31.14 116.24C30.1133 116.24 29.2067 116.067 28.42 115.72C27.6333 115.36 27.0133 114.853 26.56 114.2C26.1067 113.533 25.8733 112.727 25.86 111.78H28.56C28.5867 112.433 28.82 112.987 29.26 113.44C29.7133 113.88 30.3333 114.1 31.12 114.1C31.8 114.1 32.34 113.94 32.74 113.62C33.14 113.287 33.34 112.847 33.34 112.3C33.34 111.727 33.16 111.28 32.8 110.96C32.4533 110.64 31.9867 110.38 31.4 110.18C30.8133 109.98 30.1867 109.767 29.52 109.54C28.44 109.167 27.6133 108.687 27.04 108.1C26.48 107.513 26.2 106.733 26.2 105.76C26.1867 104.933 26.38 104.227 26.78 103.64C27.1933 103.04 27.7533 102.58 28.46 102.26C29.1667 101.927 29.98 101.76 30.9 101.76C31.8333 101.76 32.6533 101.927 33.36 102.26C34.08 102.593 34.64 103.06 35.04 103.66C35.4533 104.26 35.6733 104.973 35.7 105.8H32.96C32.9467 105.307 32.7533 104.873 32.38 104.5C32.02 104.113 31.5133 103.92 30.86 103.92C30.3 103.907 29.8267 104.047 29.44 104.34C29.0667 104.62 28.88 105.033 28.88 105.58C28.88 106.047 29.0267 106.42 29.32 106.7C29.6133 106.967 30.0133 107.193 30.52 107.38C31.0267 107.567 31.6067 107.767 32.26 107.98C32.9533 108.22 33.5867 108.5 34.16 108.82C34.7333 109.14 35.1933 109.567 35.54 110.1C35.8867 110.62 36.06 111.293 36.06 112.12C36.06 112.853 35.8733 113.533 35.5 114.16C35.1267 114.787 34.5733 115.293 33.84 115.68C33.1067 116.053 32.2067 116.24 31.14 116.24ZM39.2536 120.4L41.5536 115.34H40.9536L37.0936 106.08H39.8736L42.6536 113.06L45.5536 106.08H48.2736L41.9736 120.4H39.2536ZM53.3389 116.24C52.4589 116.24 51.6856 116.1 51.0189 115.82C50.3522 115.527 49.8189 115.127 49.4189 114.62C49.0189 114.113 48.7789 113.527 48.6989 112.86H51.2789C51.3589 113.247 51.5722 113.58 51.9189 113.86C52.2789 114.127 52.7389 114.26 53.2989 114.26C53.8589 114.26 54.2656 114.147 54.5189 113.92C54.7856 113.693 54.9189 113.433 54.9189 113.14C54.9189 112.713 54.7322 112.427 54.3589 112.28C53.9856 112.12 53.4656 111.967 52.7989 111.82C52.3722 111.727 51.9389 111.613 51.4989 111.48C51.0589 111.347 50.6522 111.18 50.2789 110.98C49.9189 110.767 49.6256 110.5 49.3989 110.18C49.1722 109.847 49.0589 109.44 49.0589 108.96C49.0589 108.08 49.4056 107.34 50.0989 106.74C50.8056 106.14 51.7922 105.84 53.0589 105.84C54.2322 105.84 55.1656 106.113 55.8589 106.66C56.5656 107.207 56.9856 107.96 57.1189 108.92H54.6989C54.5522 108.187 53.9989 107.82 53.0389 107.82C52.5589 107.82 52.1856 107.913 51.9189 108.1C51.6656 108.287 51.5389 108.52 51.5389 108.8C51.5389 109.093 51.7322 109.327 52.1189 109.5C52.5056 109.673 53.0189 109.833 53.6589 109.98C54.3522 110.14 54.9856 110.32 55.5589 110.52C56.1456 110.707 56.6122 110.993 56.9589 111.38C57.3056 111.753 57.4789 112.293 57.4789 113C57.4922 113.613 57.3322 114.167 56.9989 114.66C56.6656 115.153 56.1856 115.54 55.5589 115.82C54.9322 116.1 54.1922 116.24 53.3389 116.24ZM63.6342 116C62.5942 116 61.7609 115.747 61.1342 115.24C60.5076 114.733 60.1942 113.833 60.1942 112.54V108.22H58.4942V106.08H60.1942L60.4942 103.42H62.7542V106.08H65.4342V108.22H62.7542V112.56C62.7542 113.04 62.8542 113.373 63.0542 113.56C63.2676 113.733 63.6276 113.82 64.1342 113.82H65.3742V116H63.6342ZM71.9783 116.24C70.9783 116.24 70.0916 116.027 69.3183 115.6C68.5449 115.173 67.9383 114.573 67.4983 113.8C67.0583 113.027 66.8383 112.133 66.8383 111.12C66.8383 110.093 67.0516 109.18 67.4783 108.38C67.9183 107.58 68.5183 106.96 69.2783 106.52C70.0516 106.067 70.9583 105.84 71.9983 105.84C72.9716 105.84 73.8316 106.053 74.5783 106.48C75.3249 106.907 75.9049 107.493 76.3183 108.24C76.7449 108.973 76.9583 109.793 76.9583 110.7C76.9583 110.847 76.9516 111 76.9383 111.16C76.9383 111.32 76.9316 111.487 76.9183 111.66H69.3783C69.4316 112.433 69.6983 113.04 70.1783 113.48C70.6716 113.92 71.2649 114.14 71.9583 114.14C72.4783 114.14 72.9116 114.027 73.2583 113.8C73.6183 113.56 73.8849 113.253 74.0583 112.88H76.6583C76.4716 113.507 76.1583 114.08 75.7183 114.6C75.2916 115.107 74.7583 115.507 74.1183 115.8C73.4916 116.093 72.7783 116.24 71.9783 116.24ZM71.9983 107.92C71.3716 107.92 70.8183 108.1 70.3383 108.46C69.8583 108.807 69.5516 109.34 69.4183 110.06H74.3583C74.3183 109.407 74.0783 108.887 73.6383 108.5C73.1983 108.113 72.6516 107.92 71.9983 107.92ZM78.8914 116V106.08H81.1514L81.3714 107.42C81.6914 106.94 82.1114 106.56 82.6314 106.28C83.1647 105.987 83.7781 105.84 84.4714 105.84C86.0047 105.84 87.0914 106.433 87.7314 107.62C88.0914 107.073 88.5714 106.64 89.1714 106.32C89.7847 106 90.4514 105.84 91.1714 105.84C92.4647 105.84 93.4581 106.227 94.1514 107C94.8447 107.773 95.1914 108.907 95.1914 110.4V116H92.6314V110.64C92.6314 109.787 92.4647 109.133 92.1314 108.68C91.8114 108.227 91.3114 108 90.6314 108C89.9381 108 89.3781 108.253 88.9514 108.76C88.5381 109.267 88.3314 109.973 88.3314 110.88V116H85.7714V110.64C85.7714 109.787 85.6047 109.133 85.2714 108.68C84.9381 108.227 84.4247 108 83.7314 108C83.0514 108 82.4981 108.253 82.0714 108.76C81.6581 109.267 81.4514 109.973 81.4514 110.88V116H78.8914Z",
    fill: "#FFB900"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_10322_11211)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 134,
    width: 38,
    height: 22,
    rx: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 134,
    width: 38,
    height: 22,
    rx: 11,
    fill: "url(#paint72_linear_10322_11211)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 134,
    width: 38,
    height: 22,
    rx: 11,
    fill: "url(#paint73_linear_10322_11211)"
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3624 148.849C46.1258 148.611 46.1258 148.226 46.3624 147.988L48.7109 145.61H39.5053C39.1715 145.61 38.8985 145.335 38.8985 144.999C38.8985 144.663 39.1715 144.388 39.5053 144.388H48.7109L46.3564 142.017C46.1197 141.779 46.1197 141.394 46.3564 141.155C46.593 140.917 46.9753 140.917 47.212 141.155L50.6102 144.571C50.8469 144.81 50.8469 145.195 50.6102 145.433L47.2181 148.849C46.9814 149.081 46.593 149.081 46.3624 148.849Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10322_11211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.6234 37.0198C47.6234 38.6472 48.1023 38.7013 48.9395 38.7013V38.8775H45.43V38.7013C46.0816 38.7013 46.3074 38.349 46.3074 37.0608V30.7833C46.3074 29.8475 46.1209 29.5092 45.4565 29.5092V29.333H47.8629C50.5087 29.333 52.2634 29.6583 52.2634 32.0714C52.2634 34.4846 50.5087 34.7968 47.8629 34.7968H47.6234V37.0208V37.0198ZM47.8629 34.6197C49.4851 34.6197 50.8139 34.5797 50.8139 32.0714C50.8139 29.5632 49.4184 29.5092 47.8629 29.5092H47.6234V34.6207H47.8629V34.6197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9485 38.8782H52.7149V38.7021C53.2203 38.5529 53.2468 38.3087 53.2468 37.6171V33.8618C53.2468 33.3874 53.1408 33.1972 52.5824 33.0481V32.885L54.4038 32.4917V37.6171C54.4038 38.3758 54.4705 38.58 54.9485 38.7021V38.8782ZM53.021 30.676C53.021 30.2826 53.3135 29.9844 53.6992 29.9844C54.0848 29.9844 54.3773 30.2826 54.3773 30.676C54.3773 31.0693 54.0711 31.3676 53.6992 31.3676C53.3272 31.3676 53.021 31.0553 53.021 30.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.303 38.8778H59.0694V38.7147C59.5748 38.5655 59.6013 38.3083 59.6013 37.6167V34.7012C59.6013 33.7793 59.1224 33.1688 58.245 33.1688C57.5541 33.1688 56.9957 33.8464 56.8887 34.3349V37.6297C56.8887 38.3754 56.9555 38.5786 57.4334 38.7007V38.8769H55.1998V38.7007C55.7052 38.5516 55.718 38.3213 55.718 37.6297V33.8474C55.718 33.373 55.6111 33.1968 55.0536 33.0477V32.8845L56.8878 32.4912V33.9145C57.1666 33.1278 58.0842 32.4912 58.9222 32.4912C59.9988 32.4912 60.7565 33.0197 60.7565 34.6601V37.6158C60.7565 38.3614 60.836 38.5916 61.3012 38.7137V38.8769L61.303 38.8778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4985 38.8778H65.2649V38.7147C65.7703 38.5655 65.7968 38.3083 65.7968 37.6167V34.7012C65.7968 33.7793 65.3179 33.1688 64.4405 33.1688C63.7496 33.1688 63.1912 33.8464 63.0842 34.3349V37.6297C63.0842 38.3754 63.151 38.5786 63.6289 38.7007V38.8769H61.3953V38.7007C61.9007 38.5516 61.9135 38.3213 61.9135 37.6297V33.8474C61.9135 33.373 61.8075 33.1968 61.2491 33.0477V32.8845L63.0833 32.4912V33.9145C63.3621 33.1278 64.2797 32.4912 65.1177 32.4912C66.1943 32.4912 66.952 33.0197 66.952 34.6601V37.6158C66.952 38.3614 67.0315 38.5916 67.4967 38.7137V38.8769L67.4985 38.8778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4545 38.0099L73.6135 38.078C73.534 38.4853 73.0816 38.9998 72.3907 38.9998C72.3907 38.9998 71.3406 39.0268 71.2611 37.8608C71.0747 38.5114 70.3042 38.9998 69.3729 38.9998C69.3729 38.9998 67.8577 38.9998 67.8577 37.6035C67.8577 36.2073 68.9873 35.9491 71.2611 35.3535V34.5668C71.2611 33.1706 70.5702 32.3839 69.5064 32.8854C68.9882 33.1436 68.9087 33.4008 68.9882 33.4139C69.1481 33.4409 69.2943 33.5089 69.4004 33.6581C69.5996 33.9293 69.5466 34.3366 69.2669 34.5398C69.001 34.757 68.6153 34.702 68.4161 34.4177C68.2698 34.2145 68.2433 33.9433 68.3493 33.7531C68.4426 33.5499 68.6683 33.1436 69.3866 32.7502C69.9578 32.452 70.6095 32.492 70.6095 32.492C72.058 32.492 72.4574 33.59 72.4574 35.2034V37.5085C72.4574 37.5085 72.4446 38.3622 73.056 38.3622C73.056 38.3622 73.3613 38.3622 73.4545 38.0099ZM69.0412 37.3183C69.0412 37.7117 69.2806 38.3893 70.0913 38.3893C70.7959 38.3893 71.1286 37.8738 71.2611 37.5485V35.5287C69.7193 35.9081 69.0412 36.5046 69.0412 37.3183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1848 37.2094C79.0386 37.887 78.3605 38.999 76.7254 38.999C75.2367 38.999 73.8274 37.7518 73.8274 35.7591C73.8274 34.0916 75.0237 32.4912 77.0581 32.4912C78.3614 32.4912 78.7598 33.1017 78.8796 33.318C78.9856 33.5081 79.0121 33.7654 78.8924 33.9825C78.7196 34.2668 78.3211 34.3898 78.0415 34.2128C77.7353 34.0366 77.6421 33.6433 77.8158 33.359C77.909 33.1968 78.0552 33.0877 78.1877 33.0747C78.3074 33.0477 77.9483 32.6683 77.0581 32.6683C76.5262 32.6683 75.0639 33.0747 75.0639 35.6099C75.0639 37.4135 76.061 38.1592 77.0051 38.2533C77.9757 38.3344 78.8 37.6978 79.0395 37.1413L79.1857 37.2094H79.1848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7639 38.8779H79.5303V38.7017C80.0357 38.5526 80.0622 38.3224 80.0622 37.6308V30.1872C80.0622 29.7128 79.9424 29.5227 79.3968 29.4145V29.2384L81.2311 28.8721V37.6308C81.2311 38.3764 81.2978 38.5796 81.763 38.7017V38.8779H81.7639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3873 37.2774C87.241 37.915 86.5099 38.999 84.9407 38.999C83.2792 38.999 82.0956 37.5887 82.0956 35.7991C82.0956 33.7924 83.345 32.4912 84.9937 32.4912C86.5355 32.4912 87.5993 33.4941 87.5993 35.623H83.345C83.398 37.4536 84.1958 38.1853 85.2459 38.2943C86.0438 38.3754 86.9879 37.8739 87.2264 37.2094L87.3854 37.2774H87.3873ZM86.4569 35.4468C86.4569 33.4671 85.5932 32.6674 84.9544 32.6674C84.1968 32.6674 83.3459 33.7383 83.3459 35.4468H86.4569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 32.5028H89.62V33.9624H88.9812V32.5028H87.6011V31.8512H88.9812V30.3916H89.62V31.8512H91V32.5028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3688 28.5273H34.0964V34.3416H34.3688C36.214 34.3416 37.7256 34.296 37.7256 31.4429C37.7256 28.5898 36.1381 28.5283 34.3688 28.5283V28.5273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3734 31.4421C39.3734 34.1712 37.3774 34.5413 34.3679 34.5413H34.0955V37.07C34.0955 38.2509 34.3176 38.703 34.7252 38.8754H43.9741L39.4804 30.9369L39.3003 30.6182C39.3478 30.8661 39.3734 31.1383 39.3734 31.4403V31.4421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5994 37.1171V29.9774C32.5994 29.0248 32.4285 28.6166 31.8509 28.542L30.4938 30.9393L26 38.8759H32.1105C32.4651 38.6783 32.5994 38.1759 32.5994 37.1161V37.1171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3688 28.3268H38.0035L34.9875 23L31.9725 28.3268H34.3688Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10322_11211",
    x: 0,
    y: 0,
    width: 189,
    height: 230,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10322_11211"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10322_11211",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_10322_11211",
    x: 18,
    y: 126,
    width: 54,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10322_11211"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10322_11211",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10322_11211",
    x1: 123.207,
    y1: 153,
    x2: 123.207,
    y2: 213.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C9BBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10322_11211",
    x1: 123.207,
    y1: 204.885,
    x2: 123.207,
    y2: 222.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10322_11211",
    x1: 123.297,
    y1: 154.226,
    x2: 123.297,
    y2: 203.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#71C6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4AA1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10322_11211",
    x1: 109.506,
    y1: 153.307,
    x2: 135.546,
    y2: 159.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B7591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#086998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10322_11211",
    x1: 89.9003,
    y1: 172.201,
    x2: 89.9003,
    y2: 181.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10322_11211",
    x1: 91.1404,
    y1: 186.786,
    x2: 91.1404,
    y2: 195.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10322_11211",
    x1: 91.1404,
    y1: 192.3,
    x2: 91.1404,
    y2: 200.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10322_11211",
    x1: 97.88,
    y1: 186.786,
    x2: 97.88,
    y2: 195.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10322_11211",
    x1: 97.88,
    y1: 192.3,
    x2: 97.88,
    y2: 200.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10322_11211",
    x1: 104.62,
    y1: 186.786,
    x2: 104.62,
    y2: 195.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10322_11211",
    x1: 104.62,
    y1: 192.3,
    x2: 104.62,
    y2: 200.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10322_11211",
    x1: 116.873,
    y1: 186.786,
    x2: 116.873,
    y2: 195.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10322_11211",
    x1: 116.873,
    y1: 192.3,
    x2: 116.873,
    y2: 200.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10322_11211",
    x1: 123.613,
    y1: 186.786,
    x2: 123.613,
    y2: 195.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10322_11211",
    x1: 123.613,
    y1: 192.3,
    x2: 123.613,
    y2: 200.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10322_11211",
    x1: 130.352,
    y1: 186.786,
    x2: 130.352,
    y2: 195.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10322_11211",
    x1: 130.352,
    y1: 192.3,
    x2: 130.352,
    y2: 200.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10322_11211",
    x1: 141.993,
    y1: 187.398,
    x2: 141.993,
    y2: 195.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10322_11211",
    x1: 141.993,
    y1: 192.913,
    x2: 141.993,
    y2: 201.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10322_11211",
    x1: 148.733,
    y1: 187.398,
    x2: 148.733,
    y2: 195.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10322_11211",
    x1: 148.733,
    y1: 192.913,
    x2: 148.733,
    y2: 201.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_10322_11211",
    x1: 155.473,
    y1: 187.398,
    x2: 155.473,
    y2: 195.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_10322_11211",
    x1: 155.473,
    y1: 192.913,
    x2: 155.473,
    y2: 201.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_10322_11211",
    x1: 115.633,
    y1: 171.588,
    x2: 115.633,
    y2: 180.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_10322_11211",
    x1: 141.295,
    y1: 171.588,
    x2: 141.295,
    y2: 180.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_10322_11211",
    x1: 149.331,
    y1: 154.565,
    x2: 149.331,
    y2: 160.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C5DF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ADC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BF49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_10322_11211",
    x1: 155.458,
    y1: 155.692,
    x2: 155.458,
    y2: 159.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_10322_11211",
    x1: 123.207,
    y1: 224.756,
    x2: 123.207,
    y2: 210.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_10322_11211",
    x1: 157.608,
    y1: 211.384,
    x2: 157.608,
    y2: 207.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C5DF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ADC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BF49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_10322_11211",
    x1: 183.726,
    y1: 185.908,
    x2: 183.726,
    y2: 235.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_10322_11211",
    x1: 132.863,
    y1: 176.538,
    x2: 132.863,
    y2: 194.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_10322_11211",
    x1: 138.721,
    y1: 174.622,
    x2: 137.824,
    y2: 200.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_10322_11211",
    x1: 134.204,
    y1: 174.455,
    x2: 133.339,
    y2: 199.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_10322_11211",
    x1: 132.196,
    y1: 174.2,
    x2: 131.272,
    y2: 200.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_10322_11211",
    x1: 144.658,
    y1: 186.375,
    x2: 144.658,
    y2: 222.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_10322_11211",
    x1: 165.636,
    y1: 186.259,
    x2: 165.659,
    y2: 229.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_10322_11211",
    x1: 171.032,
    y1: 157.746,
    x2: 174.007,
    y2: 184.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_10322_11211",
    x1: 170.151,
    y1: 190.388,
    x2: 170.747,
    y2: 177.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_10322_11211",
    x1: 170.208,
    y1: 189.162,
    x2: 170.656,
    y2: 179.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_10322_11211",
    x1: 166.809,
    y1: 161.228,
    x2: 160.998,
    y2: 189.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAD7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA9F73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F48960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_10322_11211",
    x1: 166.287,
    y1: 164.724,
    x2: 167.169,
    y2: 194.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99D71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3845C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_10322_11211",
    x1: 168.433,
    y1: 158.877,
    x2: 171.241,
    y2: 184.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_10322_11211",
    x1: 164.649,
    y1: 159.307,
    x2: 167.436,
    y2: 184.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_10322_11211",
    x1: 166.32,
    y1: 185.829,
    x2: 166.32,
    y2: 200.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0444E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C41620"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_10322_11211",
    x1: 166.71,
    y1: 186.871,
    x2: 166.71,
    y2: 199.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0444E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C41620"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_10322_11211",
    x1: 166.71,
    y1: 187.455,
    x2: 166.71,
    y2: 196.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0444E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C41620"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_10322_11211",
    x1: 85.8158,
    y1: 193.141,
    x2: 85.8158,
    y2: 249.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_10322_11211",
    x1: 84.1383,
    y1: 174.216,
    x2: 84.1383,
    y2: 204.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_10322_11211",
    x1: 97.715,
    y1: 204.375,
    x2: 97.715,
    y2: 246.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#568998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_10322_11211",
    x1: 64.802,
    y1: 204.467,
    x2: 64.802,
    y2: 245.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#568998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_10322_11211",
    x1: 86.9709,
    y1: 215.452,
    x2: 86.9709,
    y2: 257.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#568998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_10322_11211",
    x1: 83.2997,
    y1: 215.354,
    x2: 83.2997,
    y2: 252.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#568998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_10322_11211",
    x1: 107.816,
    y1: 184.386,
    x2: 97.094,
    y2: 207.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_10322_11211",
    x1: 105.235,
    y1: 183.468,
    x2: 98.6693,
    y2: 207.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_10322_11211",
    x1: 93.6167,
    y1: 191.985,
    x2: 93.6167,
    y2: 219.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_10322_11211",
    x1: 89.0303,
    y1: 173.437,
    x2: 90.7872,
    y2: 205.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_10322_11211",
    x1: 85.3569,
    y1: 191.985,
    x2: 85.3569,
    y2: 219.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_10322_11211",
    x1: 85.689,
    y1: 197.967,
    x2: 85.689,
    y2: 184.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_10322_11211",
    x1: 85.2934,
    y1: 196.29,
    x2: 85.2934,
    y2: 186.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_10322_11211",
    x1: 84.491,
    y1: 177.551,
    x2: 91.5574,
    y2: 196.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_10322_11211",
    x1: 79.4606,
    y1: 178.478,
    x2: 84.8823,
    y2: 197.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_10322_11211",
    x1: 81.6496,
    y1: 176.41,
    x2: 82.9489,
    y2: 200.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_10322_11211",
    x1: 82.5523,
    y1: 173.793,
    x2: 84.2988,
    y2: 205.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C37441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#97522B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_10322_11211",
    x1: 103.653,
    y1: 192.702,
    x2: 100.344,
    y2: 192.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_10322_11211",
    x1: 101.976,
    y1: 191.843,
    x2: 101.226,
    y2: 191.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C9BBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_10322_11211",
    x1: 92.6195,
    y1: 212.012,
    x2: 95.1618,
    y2: 227.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDB991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FAAB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F5946E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EE7450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_10322_11211",
    x1: 94.091,
    y1: 216.269,
    x2: 73.762,
    y2: 186.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDB991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FAAB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F5946E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EE7450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_10322_11211",
    x1: 88.1054,
    y1: 211.693,
    x2: 90.9827,
    y2: 229.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDB991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FAAB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F5946E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EE7450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_10322_11211",
    x1: 81.9864,
    y1: 191.986,
    x2: 81.9864,
    y2: 219.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_10322_11211",
    x1: 108.682,
    y1: 219.027,
    x2: 92.1625,
    y2: 219.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_10322_11211",
    x1: 92.2101,
    y1: 219.074,
    x2: 82.9059,
    y2: 219.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_10322_11211",
    x1: 100.99,
    y1: 218.474,
    x2: 99.8511,
    y2: 218.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_10322_11211",
    x1: 64,
    y1: 156,
    x2: 24.0901,
    y2: 151.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_10322_11211",
    x1: 45,
    y1: 102.604,
    x2: 45,
    y2: 156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDA44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5F00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10322_11211"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 185,
    height: 226,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10322_11211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 16,
    fill: "white",
    transform: "translate(26 23)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSosShort);
export default __webpack_public_path__ + "static/media/SOS_Short.05cce6be36415d996b15f210692eced4.svg";
export { ForwardRef as ReactComponent };